export const isMonthly = (interval: string): boolean => interval === 'month';
